import { useMemo } from 'react';
import { currencyList } from '../../graphql/projects/models/Currencies';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { languageList } from '../../graphql/projects/models/languages';
import { projectsApiService } from '../../graphql/projects/projectsApiService';
import { GoogleAdsLocationGq } from '../../graphql/projects/models/GoogleAdsLocationGq';

export function useProjectDefaults(project: ProjectGq) {
  const projectDefaultVolumeLocationQuery = projectsApiService.queries.googleAds.useGetLocations({
    id: project?.defaultLocationId,
  });
  const projectDefaultSerpLocationQuery = projectsApiService.queries.googleAds.useGetLocations({
    id: project?.serpLocationId,
  });
  const countryQuery = projectsApiService.queries.googleAds.useGetLocations({
    targetType: 'Country',
  });

  return useMemo(() => {
    const defaultVolumeLocation: GoogleAdsLocationGq = projectDefaultVolumeLocationQuery?.result
      ? projectDefaultVolumeLocationQuery?.result[0]
      : null;
    const defaultSerpLocation: GoogleAdsLocationGq = projectDefaultSerpLocationQuery?.result
      ? projectDefaultSerpLocationQuery?.result[0]
      : null;
    return {
      volumeLanguage: languageList?.find((language) => language.id === project?.defaultLanguageId),
      volumeCountry:
        defaultVolumeLocation?.targetType === 'Country'
          ? defaultVolumeLocation
          : countryQuery?.result?.find(
              (l) => l.countryCode === defaultVolumeLocation?.countryCode
            ) ?? null,
      volumeCity: defaultVolumeLocation?.targetType !== 'Country' ? defaultVolumeLocation : null,
      serpLanguage: languageList?.find((language) => language.id === project?.serpLanguageId),
      serpCountry:
        defaultSerpLocation?.targetType === 'Country'
          ? defaultSerpLocation
          : countryQuery?.result?.find((l) => l.countryCode === defaultSerpLocation?.countryCode) ??
            null,
      serpCity: defaultSerpLocation?.targetType !== 'Country' ? defaultSerpLocation : null,
      currency:
        currencyList.find((c) => c.code === project?.currency) ??
        currencyList.find((c) => c.id === 1),
    };
  }, [
    projectDefaultVolumeLocationQuery?.query?.data?.projects?.getGoogleAdsLocations
      ?.adwordsLocations,
    countryQuery?.query?.data?.projects?.getGoogleAdsLocations?.adwordsLocations,
    projectDefaultSerpLocationQuery?.query?.data?.projects?.getGoogleAdsLocations?.adwordsLocations,
    project?.currency,
    project?.defaultLanguageId,
    project?.defaultLocationId,
    project?.serpLocationId,
    project?.serpLanguageId,
  ]);
}
